import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search, MapPin, Filter, SlidersHorizontal, Eye, Users, ChevronLeft, ChevronRight } from 'lucide-react';
const mockProperties = [{
  id: 1,
  address: 'Via Montenapoleone 12, Milano',
  price: 850000,
  size: 120,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 45,
  interested: 8
}, {
  id: 2,
  address: 'Corso Venezia 45, Milano',
  price: 1200000,
  size: 200,
  type: 'Showroom',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra + Mezzanino',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 32,
  interested: 5
}, {
  id: 3,
  address: 'Via della Spiga 8, Milano',
  price: 650000,
  size: 90,
  type: 'Boutique',
  status: 'Disponibile',
  zone: 'Quadrilatero',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 67,
  interested: 12
}, {
  id: 4,
  address: 'Via Manzoni 20, Milano',
  price: 950000,
  size: 150,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 52,
  interested: 9
}, {
  id: 5,
  address: 'Corso Como 10, Milano',
  price: 780000,
  size: 110,
  type: 'Boutique',
  status: 'In Trattativa',
  zone: 'Porta Garibaldi',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 38,
  interested: 6
}, {
  id: 6,
  address: 'Via Brera 15, Milano',
  price: 720000,
  size: 95,
  type: 'Showroom',
  status: 'Disponibile',
  zone: 'Brera',
  floor: 'Piano Terra + Seminterrato',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 41,
  interested: 7
}, {
  id: 7,
  address: 'Via Santo Spirito 10, Milano',
  price: 1100000,
  size: 180,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 58,
  interested: 11
}, {
  id: 8,
  address: 'Via Torino 28, Milano',
  price: 680000,
  size: 85,
  type: 'Boutique',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 29,
  interested: 4
}, {
  id: 9,
  address: 'Corso Buenos Aires 33, Milano',
  price: 550000,
  size: 100,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Porta Venezia',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 35,
  interested: 5
}, {
  id: 10,
  address: 'Via Verri 7, Milano',
  price: 890000,
  size: 130,
  type: 'Showroom',
  status: 'Disponibile',
  zone: 'Quadrilatero',
  floor: 'Piano Terra + Mezzanino',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 48,
  interested: 8
}, {
  id: 11,
  address: 'Via Gesù 4, Milano',
  price: 920000,
  size: 140,
  type: 'Retail',
  status: 'In Trattativa',
  zone: 'Quadrilatero',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 54,
  interested: 10
}, {
  id: 12,
  address: 'Via Borgospesso 15, Milano',
  price: 760000,
  size: 105,
  type: 'Boutique',
  status: 'Disponibile',
  zone: 'Quadrilatero',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 42,
  interested: 7
}, {
  id: 13,
  address: 'Corso Magenta 12, Milano',
  price: 620000,
  size: 88,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Magenta',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 31,
  interested: 5
}, {
  id: 14,
  address: 'Via Dante 15, Milano',
  price: 870000,
  size: 125,
  type: 'Showroom',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra + Seminterrato',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 46,
  interested: 8
}, {
  id: 15,
  address: 'Via Monte di Pietà 21, Milano',
  price: 710000,
  size: 98,
  type: 'Boutique',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 39,
  interested: 6
}, {
  id: 16,
  address: 'Corso Europa 12, Milano',
  price: 980000,
  size: 160,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 61,
  interested: 13
}, {
  id: 17,
  address: 'Via Borgonuovo 18, Milano',
  price: 590000,
  size: 82,
  type: 'Boutique',
  status: 'In Trattativa',
  zone: 'Brera',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 27,
  interested: 4
}, {
  id: 18,
  address: 'Via Solferino 8, Milano',
  price: 830000,
  size: 118,
  type: 'Showroom',
  status: 'Disponibile',
  zone: 'Brera',
  floor: 'Piano Terra + Mezzanino',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 44,
  interested: 7
}, {
  id: 19,
  address: 'Piazza San Babila 7, Milano',
  price: 1050000,
  size: 175,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 72,
  interested: 15
}, {
  id: 20,
  address: 'Via Fiori Chiari 22, Milano',
  price: 670000,
  size: 92,
  type: 'Boutique',
  status: 'In Trattativa',
  zone: 'Brera',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 33,
  interested: 5
}, {
  id: 21,
  address: 'Corso Garibaldi 45, Milano',
  price: 740000,
  size: 108,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Porta Garibaldi',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 37,
  interested: 6
}, {
  id: 22,
  address: "Via Sant'Andrea 12, Milano",
  price: 1150000,
  size: 190,
  type: 'Showroom',
  status: 'Disponibile',
  zone: 'Quadrilatero',
  floor: 'Piano Terra + Mezzanino',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 68,
  interested: 14
}, {
  id: 23,
  address: 'Corso Matteotti 5, Milano',
  price: 820000,
  size: 122,
  type: 'Retail',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 49,
  interested: 9
}, {
  id: 24,
  address: 'Via Bagutta 14, Milano',
  price: 690000,
  size: 96,
  type: 'Boutique',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 36,
  interested: 6
}, {
  id: 25,
  address: 'Via Pontaccio 19, Milano',
  price: 580000,
  size: 78,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Brera',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 26,
  interested: 4
}, {
  id: 26,
  address: 'Piazza Duomo 5, Milano',
  price: 1300000,
  size: 220,
  type: 'Showroom',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra + Primo Piano',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 85,
  interested: 18
}, {
  id: 27,
  address: 'Via Madonnina 6, Milano',
  price: 640000,
  size: 87,
  type: 'Boutique',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg',
  views: 30,
  interested: 5
}, {
  id: 28,
  address: 'Corso Vittorio Emanuele 22, Milano',
  price: 910000,
  size: 145,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg',
  views: 56,
  interested: 10
}, {
  id: 29,
  address: 'Via Orefici 2, Milano',
  price: 770000,
  size: 112,
  type: 'Showroom',
  status: 'In Trattativa',
  zone: 'Centro',
  floor: 'Piano Terra + Seminterrato',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  views: 43,
  interested: 7
}, {
  id: 30,
  address: 'Via Alessandro Manzoni 31, Milano',
  price: 1020000,
  size: 168,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp',
  views: 64,
  interested: 12
}];
export function Properties() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  // Calculate pagination
  const totalPages = Math.ceil(mockProperties.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProperties = mockProperties.slice(startIndex, endIndex);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="space-y-6" data-id="element-2024">
      <div className="flex items-center justify-between" data-id="element-2025">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2026">
          Gestione Immobili
        </h1>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal hover:bg-[#0f6b8a] transition-colors rounded-full" data-id="element-2027">
          <Plus className="w-4 h-4" data-id="element-2028" />
          Nuovo Immobile
        </button>
      </div>
      <div className="bg-white p-4 border border-gray-200 rounded-lg space-y-4" data-id="element-2029">
        <div className="flex gap-3" data-id="element-2030">
          <div className="flex-1 relative" data-id="element-2031">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-2032" />
            <input type="text" placeholder="Cerca per indirizzo, città, tipo..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2033" />
          </div>
          <button onClick={() => setShowFilters(!showFilters)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 hover:bg-gray-50 transition-colors rounded-full" data-id="element-2034">
            <SlidersHorizontal className="w-4 h-4" data-id="element-2035" />
            <span className="text-sm" data-id="element-2036">Filtri</span>
          </button>
        </div>
        {showFilters && <div className="grid grid-cols-4 gap-3 pt-3 border-t border-gray-200" data-id="element-2037">
            <select className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2038">
              <option value="" data-id="element-2039">Tutte le tipologie</option>
              <option value="retail" data-id="element-2040">Retail</option>
              <option value="showroom" data-id="element-2041">Showroom</option>
              <option value="boutique" data-id="element-2042">Boutique</option>
            </select>
            <select className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2043">
              <option value="" data-id="element-2044">Tutte le zone</option>
              <option value="centro" data-id="element-2045">Centro</option>
              <option value="quadrilatero" data-id="element-2046">Quadrilatero</option>
            </select>
            <select className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2047">
              <option value="" data-id="element-2048">Tutti gli stati</option>
              <option value="disponibile" data-id="element-2049">Disponibile</option>
              <option value="trattativa" data-id="element-2050">In Trattativa</option>
            </select>
            <select className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2051">
              <option value="" data-id="element-2052">Ordina per</option>
              <option value="price-asc" data-id="element-2053">Prezzo crescente</option>
              <option value="price-desc" data-id="element-2054">Prezzo decrescente</option>
              <option value="size-desc" data-id="element-2055">Superficie</option>
            </select>
          </div>}
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2056">
        <div className="overflow-x-auto" data-id="element-2057">
          <table className="w-full min-w-[1000px]" data-id="element-2058">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-2059">
              <tr data-id="element-2060">
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2061">
                  Immobile
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2062">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2063">
                  Superficie
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2064">
                  Piano
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2065">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2066">
                  Prezzo
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-2067">
                  Engagement
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2068">
              {currentProperties.map(property => <tr key={property.id} className="hover:bg-gray-50 transition-colors" data-id="element-2069">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2070">
                    <Link to={`/properties/${property.id}`} className="flex items-center gap-3 group" data-id="element-2071">
                      <img src={property.image} alt={property.address} className="w-16 h-16 rounded-lg object-cover group-hover:scale-105 transition-transform flex-shrink-0" data-id="element-2072" />
                      <div data-id="element-2073">
                        <p className="text-sm font-normal text-gray-900 group-hover:text-[#1388ad] transition-colors" data-id="element-2074">
                          {property.address}
                        </p>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-2075">
                          {property.zone}
                        </p>
                      </div>
                    </Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2076">
                    <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-normal" data-id="element-2077">
                      {property.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2078">
                    <p className="text-sm text-gray-900" data-id="element-2079">{property.size} m²</p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2080">
                    <p className="text-sm text-gray-600" data-id="element-2081">{property.floor}</p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2082">
                    <span className={`px-3 py-1 rounded-full text-xs font-normal ${property.status === 'Disponibile' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2083">
                      {property.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2084">
                    <p className="text-sm font-normal text-[#1388ad]" data-id="element-2085">
                      €{property.price.toLocaleString()}
                    </p>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2086">
                    <div className="flex flex-col gap-1" data-id="element-2087">
                      <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-2088">
                        <Eye className="w-3 h-3" data-id="element-2089" />
                        <span data-id="element-2090">{property.views}</span>
                      </div>
                      <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-2091">
                        <Users className="w-3 h-3" data-id="element-2092" />
                        <span data-id="element-2093">{property.interested}</span>
                      </div>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination Controls */}
        <div className="border-t border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-2094">
          <div className="text-sm text-gray-600" data-id="element-2095">
            Mostrando {startIndex + 1} -{' '}
            {Math.min(endIndex, mockProperties.length)} di{' '}
            {mockProperties.length} immobili
          </div>
          <div className="flex items-center gap-2" data-id="element-2096">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2097">
              <ChevronLeft className="w-4 h-4" data-id="element-2098" />
            </button>
            <div className="flex items-center gap-1" data-id="element-2099">
              {Array.from({
              length: totalPages
            }, (_, i) => i + 1).map(page => {
              // Show first page, last page, current page, and pages around current
              if (page === 1 || page === totalPages || page >= currentPage - 1 && page <= currentPage + 1) {
                return <button key={page} onClick={() => handlePageChange(page)} className={`min-w-[32px] h-8 px-2 text-sm rounded-lg transition-colors ${currentPage === page ? 'bg-[#1388ad] text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-2100">
                      {page}
                    </button>;
              } else if (page === currentPage - 2 || page === currentPage + 2) {
                return <span key={page} className="px-2 text-gray-400" data-id="element-2101">
                      ...
                    </span>;
              }
              return null;
            })}
            </div>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2102">
              <ChevronRight className="w-4 h-4" data-id="element-2103" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}